/*
 * Elastic Query Builder
 *
 *  TODO Fully generate aggregations here, and pass-through aggs to elastic query.
 *
 */
import { pathOr } from 'ramda';

class ElasticRequestBuilder {
  constructor() {
    // TODO
  }

  createAgg(from, to, interval, spec) {
    let name = pathOr(spec.name, ['name'], spec);
    let type = pathOr(name, ['type'], spec); // type is same as name by default
    switch (type) {
      case 'date_histogram': {
        let fixed_interval = spec?.interval || spec?.fixed_interval || null; //pathOr(null, ['interval'], spec);
        let calendar_interval = spec?.calendar_interval || null;
        let time_zone = spec?.time_zone || null;
        let offset = spec?.offset || null;
        let format = spec?.format || null;
        if (fixed_interval || calendar_interval) {
          let a = {
            type: type,
            name: name,
            min_doc_count: pathOr(0, ['min_doc_count'], spec),
          };
          if (fixed_interval) {
            a.fixed_interval = fixed_interval;
          } else {
            a.calendar_interval = calendar_interval;
          }
          if (time_zone) {
            a.time_zone = time_zone;
          }
          if (offset) {
            a.offset = offset;
          }
          if (format) {
            a.format = format;
          }
          // We allow not to specify field, then default timestamp field will be used
          if ('script' in spec) {
            a.script = spec.script;
          } else if ('field' in spec) {
            a.field = spec.field;
          }
          if ('extended_bounds' in spec) {
            a.extended_bounds = spec.extended_bounds;
          }
          return a;
        }
        break;
      }
      case 'terms': {
        let field = pathOr(null, ['field'], spec);
        if (field) {
          let a = {
            type: type,
            field: field,
            name: name,
            size: pathOr(25, ['size'], spec),
            order: pathOr({ _count: 'desc' }, ['order'], spec),
          };
          if ('missing' in spec) {
            a.missing = spec.missing;
          }
          return a;
        }
        break;
      }
      case 'sum':
      case 'stats': {
        let field = pathOr(null, ['field'], spec);
        let script = pathOr(null, ['script'], spec);
        let a = {
          type: type,
          name: name,
        };
        if (script) {
          a.script = script;
        } else {
          a.field = field;
        }
        return a;
      }
      case 'percentiles': {
        let field = pathOr(null, ['field'], spec);
        let percents = pathOr(null, ['percents'], spec);
        if (field) {
          let a = {
            type: type,
            field: field,
            name: name,
            options: {
              keyed: false, // So results in buckets will be { "key": 1.0, "value": 5.0 }
            },
          };
          if (percents) {
            a.options.percents = percents;
          }
          return a;
        }
        break;
      }
      case 'nested': {
        let path = pathOr(null, ['path'], spec);
        if (path) {
          let a = {
            type: type,
            path: path,
            name: name,
          };
          return a;
        }
        break;
      }
      case 'filter': {
        let query = pathOr(null, ['query'], spec);
        if (query) {
          let a = {
            type: type,
            query: query,
            name: name,
          };
          return a;
        }
        break;
      }
    }
    return null;
  }

  addAgg(aggs, from, to, interval, groupings) {
    for (let gSpec of groupings) {
      const agg = this.createAgg(from, to, interval, gSpec);
      if (agg) {
        aggs[agg.name] = agg;
        if ('groupings' in gSpec) {
          agg.aggregations = {};
          this.addAgg(agg.aggregations, from, to, interval, gSpec.groupings);
        }
      }
    }
  }

  // Convert grouping spec to aggregations
  groupingToAgg({ from, to, interval, groupings }) {
    if (!Array.isArray(groupings) || groupings.length <= 0) {
      return null;
    }
    let aggs = {};
    this.addAgg(aggs, from, to, interval, groupings);
    return aggs;
  }

  buildRequest({ indexPrefix, timestampField, query, from, to, size = 0, offset = 0, filters, sort, aggregations }) {
    // TODO Optimize

    let payload = {
      query: query,
      from: from,
      to: to,
      aggregations: aggregations,
    };

    if (indexPrefix) {
      payload.indexPrefix = indexPrefix;
    }

    if (timestampField) {
      payload.timestampField = timestampField;
    }

    payload.size = size;
    payload.offset = offset;

    if (sort) {
      payload.sort = sort;
    }

    if (filters) {
      payload.filters = filters;
    }

    return payload;
  }

  // Builds standard Time-Series query request to Elastic
  // Time-Series query searches across specified time interval, returns top N documents
  // and includes date_histogram aggregation with specified interval
  // for each bucket at least "count" metric is provided as time series,
  // plus query may request additional stats for particular fields, all of which will be returned as time series
  buildQueryRequest({ indexPrefix, timestampField, query, from, to, interval, size = 0, offset = 0, filters, sort }) {
    // TODO Call buildRequest instead

    // Base payload
    let payload = {
      query: query,
      from: from,
      to: to,
      aggregations: {
        timeline: {
          type: 'date_histogram',
          interval: interval,
          // To ensure gaps are filled
          min_doc_count: 0,
          extendedBounds: {
            min: from,
            max: to,
          },
        },
      },
    };

    if (indexPrefix) {
      payload.indexPrefix = indexPrefix;
    }
    if (timestampField) {
      payload.timestampField = timestampField;
    }

    payload.size = size;
    payload.offset = offset;

    if (sort) {
      payload.sort = sort;
    }

    if (filters) {
      payload.filters = filters;
    }

    return payload;
  }
}

let elasticRequestBuilder = new ElasticRequestBuilder();
export { elasticRequestBuilder };
